import React from "react";

import { Avatar, Box, Paper, Stack, Typography } from "@mui/material";

import { getNameInitials } from "@/utils";

interface UserCardProps {
  name: string;
  role?: string;
  avatarUrl?: string;
}

export const UserCard: React.FC<UserCardProps> = ({ name, role, avatarUrl }) => {
  return (
    <Paper variant="outlined">
      <Stack direction="row" alignItems="center" spacing={2} p={2}>
        <Avatar
          src={avatarUrl}
          sx={{
            backgroundColor: "primary.main",
          }}
        >
          <Typography variant="h4" color="primary.contrastText">
            {getNameInitials(name)}
          </Typography>
        </Avatar>
        <Box>
          <Typography variant="h5" color="text.primary">
            {name}
          </Typography>
          {role && (
            <Typography variant="body2" color="text.secondary">
              {role}
            </Typography>
          )}
        </Box>
      </Stack>
    </Paper>
  );
};
